import { useProfiling } from 'context/Profiling';
import { useEffect } from 'react';
export default function useRouteBase(props) {
    const { perf } = useProfiling();
    const airmeetId = props?.computedMatch?.params?.id;

    useEffect(() => {
        if (airmeetId) {
            perf.addAttribute('airmeetId', airmeetId);
        }
    }, [airmeetId, perf]);

    return null;
}
